"use strict";
"use client";

exports.__esModule = true;
exports.default = useOverlayOffset;
var _react = require("react");
var _hasClass = _interopRequireDefault(require("dom-helpers/hasClass"));
var _ThemeProvider = require("./ThemeProvider");
var _Popover = _interopRequireDefault(require("./Popover"));
var _Tooltip = _interopRequireDefault(require("./Tooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// This is meant for internal use.
// This applies a custom offset to the overlay if it's a popover or tooltip.
function useOverlayOffset(customOffset) {
  var overlayRef = (0, _react.useRef)(null);
  var popoverClass = (0, _ThemeProvider.useBootstrapPrefix)(undefined, 'popover');
  var tooltipClass = (0, _ThemeProvider.useBootstrapPrefix)(undefined, 'tooltip');
  var offset = (0, _react.useMemo)(function () {
    return {
      name: 'offset',
      options: {
        offset: function offset() {
          if (customOffset) {
            return customOffset;
          }
          if (overlayRef.current) {
            if ((0, _hasClass.default)(overlayRef.current, popoverClass)) {
              return _Popover.default.POPPER_OFFSET;
            }
            if ((0, _hasClass.default)(overlayRef.current, tooltipClass)) {
              return _Tooltip.default.TOOLTIP_OFFSET;
            }
          }
          return [0, 0];
        }
      }
    };
  }, [customOffset, popoverClass, tooltipClass]);
  return [overlayRef, [offset]];
}